/* global _ */
import { orderBy } from 'lodash';

/* @ngInject */
export default class {
  constructor($q, $log, ApiClass, ProfileClass) {
    this.$q = $q;
    this.$log = $log;
    this.ApiClass = ApiClass;
    this.ProfileClass = ProfileClass;
    this.category_arr = [];
    this.categories_id = [];
    this.category_dict = {};
    this._request = false;
    this._request_error = false;
  }

  loadCategories(update) {
    if (!update && (this._request && !this._request_error)) {
      return this._request;
    }

    this._request = this.$q((resolve, reject) => {
      const company_id = this.ProfileClass.company_id;

      this.ApiClass.companiesIdTypeGet({
        id: company_id,
        type: 'categories',
        manage: false
      })
        .then(({ data: { items } }) => {
          if (_.isEmpty(items)) {
            return resolve({
              id: this.categories_id,
              arr: this.category_arr,
              obj: this.category_dict
            });
          }

          const categories = items.map(category => {
            if (!category.industry) {
              category.industry = 'Misc';
              category.industry_basic = 'Misc';
            }

            this.categories_id.push(category.category_id);
            this.category_dict[category.category_id] = category;

            return category;
          });

          this.category_arr = orderBy(categories, ['industry', 'name'], ['asc', 'asc']);

          resolve({
            id: this.categories_id,
            arr: this.category_arr,
            obj: this.category_dict
          });
        })
        .catch(error => {
          this._request_error = true;
          this.$log.error(error);
          reject(error);
        });
    });

    return this._request;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/CategoryClass.js